import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetChatExpertHeader($id: ID!) {
    chat(id: $id) {
      id
      status
      rating
      isAssignedToAgent
      expert {
        id
        name
        photoUrl
      }
      isAutomated {
        id
        action
      }
    }
  }
`);
